<i18n>
{
"en": {
  "MANAGEROUTES": "Manage Routes",
  "BUSNUMBER": "Bus Number",
  "NAME": "Name",
  "DRIVER": "Driver",
  "SUPERVISOR": "Supervisor",
  "TOTALSTUDENTS": "Total Students",
  "ADDNEWROUTE": "Add New Route",
  "CHOOSEFILTERBY": "Choose Filer By",
  "LOADING": "Loading...",
  "SEARCHROUTENAME": "Search Route Name",
  "SEARCHBUS": "Search Bus",
  "SEARCHDRIVER": "Search Driver",
  "SEARCHSUPERVISOR": "Search Supervisor",
  "TOTALSTOPS": "Total Stops",
  "EDITROUTE": "Edit Route",
  "ROUTENAME": "Route Name",
  "BUSNAME": "Bus Name",
  "DRIVERNAME": "Driver Name",
  "SUPERVISORNAME": "Supervisor Name",
  "ACTIVE": "Active",
  "INACTIVE": "Inactive",
  "STATUS": "Status"
},
"ar": {
  "MANAGEROUTES": "ادارة خطوط السير",
  "BUSNUMBER": "رقم الحافلة",
  "NAME": "الاسم",
  "DRIVER": "السائق",
  "SUPERVISOR": "المشرفة",
  "TOTALSTUDENTS": "إجمالي الطلاب",
  "ADDNEWROUTE": "اضافة خط سير جديد",
  "CHOOSEFILTERBY": "اختر الفلتر المطلوب",
  "LOADING": "جار التحميل...",
  "SEARCHROUTENAME": "ابحث عن خط سير",
  "SEARCHBUS": "ابحث عن الحافلة",
  "SEARCHDRIVER": "ابحث عن السائق",
  "SEARCHSUPERVISOR": "ابحث عن المشرفة",
  "TOTALSTOPS": "اجمالي التوقفات",
  "EDITROUTE": "تحرير خط السير",
  "ROUTENAME": "اسم خط السير",
  "BUSNAME": "اسم الحافلة",
  "DRIVERNAME": "اسم السائق",
  "SUPERVISORNAME": "اسم المشرفة",
  "STATUS": "الحالة",
  "ACTIVE": "مفعل",
  "INACTIVE": "غير مفعل"
  }
}
</i18n>
<template>
  <div>
    <el-card class="card-border" ref="card" :body-style="{ padding: 0 }">
      <div slot="header" class="clearfix">
        <span style="line-height: 36px;" class="title">{{$t('MANAGEROUTES')}}</span>
        <el-button :disabled="!isAllowed('save')" @click="$router.push({path:'/transportation/route/create'})" icon="plus">{{$t('ADDNEWROUTE')}}</el-button>
      </div>

      <div class="filters" ref="filter">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-select  v-model="filter" @change="changedFilter" :placeholder="$t('CHOOSEFILTERBY')">
              <el-option
                v-if="item.value!=active_filter"
                :key="index" v-for="(item, index) in options"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4" v-if="active_filter=='name'">
            <el-input :placeholder="$t('SEARCHROUTENAME')" v-model="TourName"></el-input>
          </el-col>    
           <el-col :span="4" v-if="active_filter=='label'">
            <el-input :placeholder="$t('SEARCHBUS')" v-model="Label"></el-input>
          </el-col>
          <el-col :span="4" v-if="active_filter=='driverName'">
            <el-input :placeholder="$t('SEARCHDRIVER')" v-model="FullName"></el-input>
          </el-col>
          <el-col :span="4" v-if="active_filter=='monitorName'">
            <el-input :placeholder="$t('SEARCHSUPERVISOR')" v-model="FullName"></el-input>
          </el-col>
                          
        </el-row>
      </div>
      <el-table
        v-loading="loading" 
        :element-loading-text="$t('LOADING')"
        :data="listRoutes"
        highlight-current-row
        @current-change="handleCurrentChange"
        :height="tableHeight"
        :default-sort="{prop: 'DraftAuthor', order: 'descending'}"
        stripe
        style="width: 100%">
        <el-table-column
          :label="$t('NAME')"
          min-width="200"
          class="left"
        >

          <template slot-scope="scope">
            <el-tag style="display:block; text-align:center;"  v-bind:style="'background-color:' + scope.row.RouteColor">
              <el-button type="text" @click="isAllowed('save') ? $router.push({path:'/transportation/route/'+scope.row.TourID}) : ''" style="color:#fff; padding:0">{{scope.row.TourName}}</el-button>
            </el-tag>
          </template>
        </el-table-column>
              <el-table-column
          prop="bus.Label"
          :label="$t('BUSNUMBER')"
          min-width="140"
          align="left"
          sortable>
        </el-table-column>

        <el-table-column
          :label="$t('DRIVER')"
          min-width="200"
          align="left"
          sortable>
          <template slot-scope="scope">
            <img :src="getAsset(scope.row.driver.ImagePath, 'driver')" alt="" class="img-circle">
            {{_FullName({NameEN: scope.row.driver.FullName_EN, NameAR: scope.row.driver.FullName_AR})}}            
          </template>
        </el-table-column>

        <el-table-column
          :label="$t('SUPERVISOR')"
          min-width="200"
          align="left"
          sortable>
          <template slot-scope="scope">
            <img :src="getAsset(scope.row.supervisor.ImagePath, 'supervisor')" alt="" class="img-circle">
            {{_FullName({NameEN: scope.row.supervisor.FullName_EN, NameAR: scope.row.supervisor.FullName_AR})}}
          </template>
        </el-table-column>

        <el-table-column
          prop="count_students"
          min-width="130"
          :label="$t('TOTALSTUDENTS')"
          align="center"
          sortable>
        </el-table-column>

        <el-table-column
          prop="count_stops"
          min-width="120"
          :label="$t('TOTALSTOPS')"
          align="center"
          sortable>


        </el-table-column>

        <el-table-column
          :label="$t('STATUS')"
          min-width="200"
          align="center"
          sortable>
          <template slot-scope="scope">
              <el-tag
                :type="parseInt(scope.row.Deleted) !== 1  ? 'success' : 'danger'"
                close-transition>{{parseInt(scope.row.Deleted) !== 1 ? $t('ACTIVE') : $t('INACTIVE')}}
              </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          label=""
          min-width="50"
          align="center"
          class="actions">

          <template slot-scope="scope">
            <el-tooltip v-if="isAllowed('save')" :content="$t('EDITROUTE')" placement="top">
              <el-button type="text" @click="$router.push({path:'/transportation/route/'+scope.row.TourID})"><i class="fa fa-pencil"></i></el-button>
            </el-tooltip>            
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
  
  export default {
    data () {
      return {
        filter: null,
        active_filter: 'name',
        loading: true,
        routes: [],
        FullName: '',
        TourName: '',
        Label: '',
        currentRow: null,
        tableHeight: 0
      }
    },
    mounted () {
      this.switchLanguage()
      this.tableHeight = window.innerHeight - (this.$refs.card.$el.children[0].offsetHeight + this.$refs.filter.offsetHeight + 53)
      this.getRoutes()
    },
    computed: {
      listRoutes () {
        let routes = this.routes
        if (this.active_filter === 'monitorName') routes = this.filterBy(routes, this.FullName, ['supervisor.FullName_EN', 'supervisor.FullName_AR'])
        if (this.active_filter === 'driverName') routes = this.filterBy(routes, this.FullName, ['driver.FullName_EN', 'driver.FullName_AR'])
        if (this.active_filter === 'name') routes = this.filterBy(routes, this.TourName, 'TourName')
        if (this.active_filter === 'label') routes = this.filterBy(routes, this.Label, ['bus.Label'])
        return routes
      },
      options () {
        let options = [{
          value: 'name',
          label: this.$t('ROUTENAME')
        }, {
          value: 'label',
          label: this.$t('BUSNAME')
        }, {
          value: 'driverName',
          label: this.$t('DRIVERNAME')
        }, {
          value: 'monitorName',
          label: this.$t('SUPERVISORNAME')
        }]
        return options
      }
    },
    methods: {
      handleCurrentChange (val) {
        this.currentRow = val
      },
      getRoutes () {
        let self = this
        if (!self.loading) return
        this.$http.get('/route')
          .then(function (response) {
            self.routes = response.data
            self.loading = false
          })
          .catch(function (res) {
            if (res instanceof Error) {
              console.log(res.message)
            } else {
              console.log(res.data)
            }
          })
      },
      filterBy (arr, search, delimiter) {
        if (!search) return arr
        let res = []
        arr.filter(function (el) {
          if (typeof delimiter === 'object') {
            let regx = new RegExp('(?:^|\\s)' + search, 'ig')
            let dele1 = delimiter[0].split('.')
            if (el[dele1[0]] && regx.test(el[dele1[0]][dele1[1]])) res.push(el)
            if (delimiter[1]) {
              let dele2 = delimiter[1].split('.')
              if (el[dele2[0]] && regx.test(el[dele2[0]][dele2[1]])) res.push(el)
            }
          } else {
            search = '^' + search
            if (new RegExp(search, 'i').test(el[delimiter])) res.push(el)
          }
        })
        return res
      },
      removeFilter (filter) {
        this.changeFilter()
        this.filter = ''
        this.listDrivers
      },
      changeFilter () {
        this.FullName = this.PersonID = this.Nationality = ''
      },
      changedFilter (val) {
        if (val === null) return
        this.active_filter = val
        this.filter = null
      }
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// Route.vue?959bef96